'use strict'

const SEGMENT = /^[^/?#\\]+$/

function storageKey (application) {

  return `superturbo-designer-selection:${application}`
}

function emptySelection () {

  return { spreadsheet: '', page: '' }
}

function isSegment (value) {

  return typeof value === 'string' && value.length > 0 && value !== '.' && value !== '..' && SEGMENT.test(value)
}

function readDesignerSelection (storage, application) {

  if (!storage || !isSegment(application)) return emptySelection()

  try {

    const raw = storage.getItem(storageKey(application))

    if (!raw) return emptySelection()

    const parsed = JSON.parse(raw)

    return {
      spreadsheet: isSegment(parsed && parsed.spreadsheet) ? parsed.spreadsheet : '',
      page: isSegment(parsed && parsed.page) ? parsed.page : ''
    }
  } catch (err) {

    return emptySelection()
  }
}

function rememberDesignerSelection (storage, application, params) {

  const current = readDesignerSelection(storage, application)

  if (!storage || !isSegment(application)) return current

  const next = {
    spreadsheet: current.spreadsheet,
    page: current.page
  }

  if (params && isSegment(params.spreadsheet)) next.spreadsheet = params.spreadsheet

  if (params && isSegment(params.page)) next.page = params.page

  if (next.spreadsheet === current.spreadsheet && next.page === current.page) return current

  storage.setItem(storageKey(application), JSON.stringify(next))

  return next
}

function designerSectionPath (application, section, selection) {

  const base = `/${application}/${section}`

  if (!isSegment(application)) return base

  if (section === 'spreadsheets' && selection && isSegment(selection.spreadsheet)) {

    return `${base}/${selection.spreadsheet}`
  }

  if (section === 'design' && selection && isSegment(selection.page)) {

    return `${base}/${selection.page}`
  }

  return base
}

module.exports = {
  readDesignerSelection,
  rememberDesignerSelection,
  designerSectionPath
}
